import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./Components/Navbar";
import Footer from "./Components/Footer";
import Home from "./Pages/Home";
import "./Styles/global.module.css";
import AboutMe from "./Pages/AboutMe";
import Dots from "./Components/Dots";
import Projects from "./Pages/Projects";
import ContactMe from "./Pages/ContactMe";

const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag !== "function") return;

    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location]);

  return null;
};

const App = () => {
  return (
    <BrowserRouter>
      <Analytics />
      <Navbar />
      <Dots />
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/projects" element={<Projects />} />
        <Route exact path="/contactme" element={<ContactMe />} />
        <Route exact path="/aboutme/*" element={<AboutMe />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
};

export default App;
